<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <b-container>
      <b-row align-v="center">
        <b-col cols="auto">
          <v-btn class="btn-return" @click="$router.go(-1)">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i>
            VOLTAR
          </v-btn>
        </b-col>
        <b-col>
          <h1 class="title-pages">CONFIGURAÇÃO DE NOTIFICAÇÃO ANTECIPADA</h1>
        </b-col>
      </b-row>
      <b-overlay :show="loading" opacity="0.99">
        <b-row>
          <b-col>
            <b-card>
              <div class="row">
                <div class="col-md-12">
                  <label for="allow_advance_notification"
                    >ATIVAR CONFIGURAÇÃO</label
                  >
                  <select
                    v-model="allow_advance_notification"
                    class="form-control"
                    @change="changeAllow"
                  >
                    <option value="NAO">NÃO</option>
                    <option value="SIM">SIM</option>
                  </select>
                </div>
                <div
                  v-if="allow_advance_notification == 'SIM'"
                  class="col-md-3"
                >
                  <label for="advance_notification_separate"
                    >NOTIFICAR PARA SEPARAR</label
                  >
                  <select
                    v-model="allow_advance_notification_separate"
                    class="form-control"
                  >
                    <option value="NAO">NÃO</option>
                    <option value="SIM">SIM</option>
                  </select>
                </div>
                <div
                  v-if="allow_advance_notification == 'SIM'"
                  class="col-md-6"
                >
                  <label for="allow_advance_notification"
                    >NOTIFICAR QUANTOS MINUTOS ANTES?</label
                  >
                  <input
                    type="number"
                    v-model="advance_notification_separate"
                    class="form-control"
                  />
                  (<code>MÍNIMO</code> 1 MINUTO; <code>MÁXIMO</code> 90 MINUTOS)
                </div>
                <div class="col-md-12"></div>
                <div
                  v-if="allow_advance_notification == 'SIM'"
                  class="col-md-3"
                >
                  <label for="advance_notification_check"
                    >NOTIFICAR PARA ADMINISTRAR</label
                  >
                  <select
                    v-model="allow_advance_notification_check"
                    class="form-control"
                  >
                    <option value="NAO">NÃO</option>
                    <option value="SIM">SIM</option>
                  </select>
                </div>
                <div
                  v-if="allow_advance_notification == 'SIM'"
                  class="col-md-6"
                >
                  <label for="allow_advance_notification"
                    >NOTIFICAR QUANTOS MINUTOS ANTES?</label
                  >
                  <input
                    type="number"
                    v-model="advance_notification_check"
                    class="form-control"
                  />
                  (<code>MÍNIMO</code> 1 MINUTO; <code>MÁXIMO</code> 90 MINUTOS)
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <errors-messages :errors="errors" />
      </b-overlay>
      <b-row align-h="end">
        <b-col cols="auto">
          <confirmation-dialog
            message-title="CONFIRMAÇÃO"
            message-body="TEM CERTEZA QUE DESEJA SALVAR?"
            open-class="btn-save"
            open-text="SALVAR"
            openLeftIcon="fa-check"
            @yes="save"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import ConfirmationDialog from "../templates/Components/ConfirmationDialog";

import api from "../services/api";

import toast from "../lib/ToastNotification";

export default {
  name: "AdvanceNotification",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    ConfirmationDialog,
  },

  data() {
    return {
      errors: [],

      allow_advance_notification: "NAO",
      allow_advance_notification_separate: "NAO",
      allow_advance_notification_check: "NAO",
      advance_notification_separate: null,
      advance_notification_check: null,

      loading: false,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    changeAllow() {
      let { allow_advance_notification } = this;

      if (allow_advance_notification == "SIM") {
        this.allow_advance_notification_separate = "NAO";
        this.allow_advance_notification_check = "NAO";
      } else {
        this.allow_advance_notification_separate = "NAO";
        this.allow_advance_notification_check = "NAO";
      }
    },

    async retrieve() {
      await this.get();
    },

    async get() {
      try {
        this.loading = true;

        const response = await api.get(
          "/rest-home/settings/advance-notification"
        );

        const {
          error,
          errors,
          allow_advance_notification,
          advance_notification_separate,
          advance_notification_check,
        } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.allow_advance_notification = allow_advance_notification
            ? "SIM"
            : "NAO";

          if (allow_advance_notification == 1) {
            this.allow_advance_notification_separate = "SIM";
          }
          if (allow_advance_notification == 2) {
            this.allow_advance_notification_check = "SIM";
          } else if (allow_advance_notification == 3) {
            this.allow_advance_notification_separate = "SIM";
            this.allow_advance_notification_check = "SIM";
          }

          this.advance_notification_separate = advance_notification_separate;
          this.advance_notification_check = advance_notification_check;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },

    async save() {
      try {
        this.loading = true;

        let {
          allow_advance_notification,
          allow_advance_notification_separate,
          allow_advance_notification_check,
          advance_notification_separate,
          advance_notification_check,
        } = this;

        const data = {
          allow_advance_notification,
          allow_advance_notification_separate,
          allow_advance_notification_check,
          advance_notification_separate,
          advance_notification_check,
        };

        const response = await api.patch(
          "/rest-home/settings/advance-notification",
          data
        );

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message);
          this.retrieve();
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
  },
};
</script>
